'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alias = require('./alias');

var _alias2 = _interopRequireDefault(_alias);

var _STR_ADDRESS = require('./_constants/STR_ADDRESS');

var _STR_ADDRESS2 = _interopRequireDefault(_STR_ADDRESS);

var _STR_ADDRESS_LC = require('./_constants/STR_ADDRESS_LC');

var _STR_ADDRESS_LC2 = _interopRequireDefault(_STR_ADDRESS_LC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Address = (0, _alias2.default)(_STR_ADDRESS_LC2.default, _STR_ADDRESS2.default); /**
                                                                                      * Alias for the address tag.  The Address tag defines the contact information
                                                                                      * for the owner of a document or article.  If contained within <body> it will
                                                                                      * denote the contact information for the document. If contained within <article>
                                                                                      * it will denote the contact information for that article.
                                                                                      *
                                                                                      * @module Address
                                                                                      * @func
                                                                                      * @since 1.0.0
                                                                                      * @param {Object} props
                                                                                      */

exports.default = Address;